const ServiceZone = () => {
  return (
    <section
      id="zona-servicio"
      className="relative py-32 bg-cover bg-center"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/6bfd0f588d4d946b37bb13d0851cb7cd.jpg')`,
      }}
    >
      <div className="absolute inset-0 bg-primary/85"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <i className="ri-map-pin-line text-6xl"></i>
        </div>

        <h2 className="text-5xl font-bold mb-8">Trabajamos en toda la Costa del Sol, Málaga y Cádiz</h2>

        <p className="text-xl mb-8 text-white/95">
          <strong>Radio de servicio: 200 km desde Manilva</strong>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <div>
            <h3 className="text-2xl font-semibold mb-4">Costa del Sol Occidental</h3>
            <p className="text-lg text-white/90">
              Estepona • Marbella • San Pedro • Benahavís • Manilva • Casares • Sotogrande • Sabinillas • San Roque
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-4">Provincia de Málaga</h3>
            <p className="text-lg text-white/90">
              Málaga • Mijas • Fuengirola • Benalmádena • Torremolinos • Ronda • Antequera • Vélez-Málaga • Nerja • Torrox
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold mb-4">Provincia de Cádiz</h3>
            <p className="text-lg text-white/90">
              Algeciras • La Línea • Tarifa • Cádiz • Jerez • Conil • Chiclana • El Puerto de Santa María
            </p>
          </div>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8 max-w-3xl mx-auto">
          <p className="text-lg text-white/95">
            <strong>¿Tu zona no aparece en la lista?</strong><br />
            Trabajamos en toda Andalucía occidental. Consúltanos sin compromiso y te confirmamos disponibilidad.
          </p>
        </div>

        <a
          href="https://wa.me/34640877479"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-3 bg-white text-primary rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          Consultar disponibilidad en tu zona
        </a>
      </div>
    </section>
  );
};

export default ServiceZone;